import axios from 'axios';
import { utils } from '../utils/utils';

const watermarkDataKey = 'watermarkData';
const apiBase = window.location.protocol + '//progallery.wix.com/_api/pro-gallery-editor-webapp/v1/gallery/';

class WatermarkApi {
  constructor(dataKey) {
    this.dataKey = dataKey;
    this.defaultWatermarkData = {
      position: 9,
      size: 40,
      opacity: 40,
      imageUrl: '8bb438_9ad16b69fd1b4ab29324f97f1323b05a~mv2.png',
      imageRatio: 1.42517815
    };
    this.origOpacity = 40;

    this.emptyWatermarkData = {
      position: 1,
      size: 1,
      opacity: 1,
      imageUrl: '8bb438_39a78b46d4fe47069da63da9348b4ee5~mv2.png',
      imageRatio: 1,
    };

    this.cachedWatermark = {
      default: this.defaultWatermarkData
    }

    this.disableWatermark = this.disableWatermark.bind(this);
    this.enableWatermark = this.enableWatermark.bind(this);
  }

  generateApiUrl(galleryId, instance) {
    return apiBase + galleryId + '?isStore=true&instance=' + instance;
  }

  applyWatermarkOnMediaDialogResult(mediaResult, galleryId, instance) {
    return new Promise((resolve, reject) => {
      if (mediaResult && mediaResult.length) {
        let watermarSave = null;
        this.getWatermarkData()
          .then(watermarkData => {
            const { imageUrl, position, size, opacity } = watermarkData;
            watermarSave = watermarkData;
            var payload = {
              wm: 'media/' + imageUrl,
              wmop: opacity,
              wmpos: position,
              wmscl: size,
              files: mediaResult.map(item => {
                return { file_name: item.fileName }
              })
            };
            return axios.post(`${window.location.protocol}//progallery.wix.com/editor/api/v1/watermark/gallery/${galleryId}?instance=${instance}&isStore=true`, payload, {
              withCredentials: true,
              xsrfCookieName: null
            })
          })
          .then(response => {
            resolve(watermarSave);
          });
      } else {
        reject();
      }
    });
  }

  getCompId() {
    return new Promise((resolve, reject) => {
      let compId = null;
      if (window.isFullscreen) {
        compId = utils.getWorkerWindow()['pro-gallery-fullscreen-comp-id'];
      } else {
        compId = Wix.Utils.getOrigCompId() || Wix.Utils.getCompId() || 'default';
      }
      resolve(compId);
    });
  }

  getDataKey() {
    return new Promise((resolve, reject) => {
      this.getCompId()
        .then(compId => {
          const dataKey = `${this.dataKey}-${compId}`;
          resolve(dataKey);
        });
    });
  }

  saveWatermark({ position, opacity, size, imageUrl, imageRatio }, galleryId, instance) {
    //save watermark to store api
    return axios.put(this.generateApiUrl(galleryId, instance), {
      settings: {
        watermark: { position, opacity, size, imageUrl, imageRatio }
      }
    }, {
      withCredentials: true,
      xsrfCookieName: null
    }).then((data) => {
      return this._updateMediaWatermark(imageUrl, opacity, position, size, galleryId, instance);
    });
  }

  getCachedWatermark(compId) {
    return this.cachedWatermark[compId] || this.defaultWatermarkData;
  }

  disableWatermark(galleryId, instance) {
    if (utils.isDev()) console.log("Disabling watermark");
    this.getCompId().then(compId => {
      let { position, size, opacity, imageUrl, imageRatio } = this.getCachedWatermark(compId);
      this.origOpacity = opacity; //save original opacity of the watermark
      opacity = 0;
      return this.saveWatermark({ position, size, opacity, imageUrl, imageRatio }, galleryId, instance)
    });
  }

  enableWatermark(galleryId, instance) {
    if (utils.isDev()) console.log("Enabling watermark");
    this.getCompId().then(compId => {
      const { position, size, imageUrl, imageRatio } = this.getCachedWatermark(compId);
      const opacity = this.origOpacity; //retrieve original opacity of the watermark
      return this.saveWatermark({ position, size, opacity, imageUrl, imageRatio }, galleryId, instance)
    });
  }

  _updateMediaWatermark(imageUrl, opacity, position, size, galleryId, instance) {
    return new Promise((resolve, reject) => {
      var payload = {
        wm: 'media/' + imageUrl,
        wmop: opacity,
        wmpos: position,
        wmscl: size,
      };
      return axios.post(`${window.location.protocol}//progallery.wix.com/editor/api/v1/watermark/gallery/${galleryId}?instance=${instance}&isStore=true`, payload, {
          withCredentials: true,
          xsrfCookieName: null
        })
        .then(() => {
          resolve();
        })
    });
  }

  getWatermarkDataFromGallerySettingsSync() {
    let watermarkData = null;
    if (window.prerenderedGallery && prerenderedGallery.gallerySettings) {
      let objGallerySettings = null;
      if (typeof prerenderedGallery.gallerySettings === 'string') {
        try {
          objGallerySettings = JSON.parse(utils.stripSlashes(prerenderedGallery.gallerySettings));
        } catch (error) {

        }
      } else if (typeof prerenderedGallery.gallerySettings === 'object') {
        objGallerySettings = prerenderedGallery.gallerySettings;
      }

      if (objGallerySettings) {
        watermarkData = objGallerySettings.watermark;
        if (watermarkData) {
          if (typeof watermarkData === 'string') {
            try {
              watermarkData = JSON.parse(watermarkData);
            } catch (error) {
              console.error(`watermarkApi - watermark from gallery settings (${watermarkData}) is invalid`, error);
            }
          }
        }
      }
    }

    return watermarkData;
  }

  getWatermarkDataFromServerAsync(galleryId) {
    galleryId = galleryId || window.galleryId;
    const instance = window.instance;
    return new Promise((resolve, reject) => {
      if (instance && galleryId) {
        axios.get(`${window.location.protocol}//progallery.wix.com/_api/pro-gallery-editor-webapp/v1/gallery/${galleryId}?instance=${instance}&isStore=true`, {
            withCredentials: true,
            xsrfCookieName: null
          })
          .then(response => {
            const data = response.data;

            if (data && (typeof (data) === 'object') && data.settings && data.settings.watermark) {
              resolve(data.settings.watermark);
            } else {
              reject(`watermarkApi - getWatermarkDataFromServerAsync - returned data from server is corrupt`);
            }
          }).catch(e => {
            reject(`watermarkApi - getWatermarkDataFromServerAsync - request error`)
          });
      } else {
        reject(`watermarkApi - getWatermarkDataFromServerAsync - no galleryId (${galleryId}) or instance (${instance})`);
      }
    });

  }

  getWatermarkData(galleryId) {
    return new Promise((resolve, reject) => {
      this.getCompId().then(compId => {
        if (this.cachedWatermark[compId] && !utils.isEditor()) {
          // if (utils.isDev()) console.log('Getting cached watermark');
          resolve(this.cachedWatermark[compId]);
        } else {
          this.cachedWatermark[compId] = this.getWatermarkDataFromGallerySettingsSync();
          // this.cachedWatermark = this.defaultWatermarkData; //set the default watermark until the Promise will resolve
          utils.isDev() && console.log('Getting public watermark');
          if (this.cachedWatermark[compId]) {
            resolve(this.cachedWatermark[compId]);
          } else { // fall back to data.public
            this.getWatermarkDataFromServerAsync(galleryId)
              .then(watermarkData => {
                this.cachedWatermark[compId] = watermarkData;
                resolve(this.cachedWatermark[compId]);
              })
              .catch(e => {
                utils.isDev() && console.log('Getting watermark from server failed - ', e);
                this.cachedWatermark[compId] = new Promise(() => {
                  this.getDataKey()
                    .then(dataKey => {
                      if (Wix && Wix.Data && Wix.Data.Public) {
                        Wix.Data.Public.get(dataKey, { scope: Wix.Data.SCOPE.APP }, data => {
                          if (utils.isDev()) console.log('Got watermark from Data.Public', data);
                          const parsedData = JSON.parse(data[dataKey]);
                          this.cachedWatermark[compId] = parsedData;
                          resolve(parsedData);
                        }, e => {
                          if (utils.isDev()) console.log('cannot fetch watermark from Data.Public', e);

                          this.cachedWatermark[compId] = this.defaultWatermarkData;
                          resolve(this.cachedWatermark[compId]);
                        });
                      } else {
                        if (utils.isDev()) console.log('Cannot get watermark from Data.Public (wix not found)');
                        reject('Wix not found');
                      }
                    });
                });
              });
          }
        }
      });
    });
  }
}

const api = new WatermarkApi(watermarkDataKey);
window['watermarkApi'] = api
module.exports = api;



// WEBPACK FOOTER //
// ./store/watermarkApi2.js